module.exports = __webpack_public_path__ + "img/change-percent.073da661.svg";